import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

type HeaderFieldsState = {
  requestId: string;
  api?: string;
};

type HeaderFieldsActions = {
  setRequestId: (requestId: string) => void;
  setApiValue: (apiValue: string) => void;
};

const initialState: HeaderFieldsState = {
  requestId: '',
};

export const headerFieldsStore: StateCreator<HeaderFieldsState & HeaderFieldsActions> = set => {
  return {
    ...initialState,

    setRequestId: (requestId: string) => {
      set(prevState => {
        return {
          ...prevState,
          requestId,
        };
      });
    },

    setApiValue: (apiValue: string) => {
      set(prevState => {
        return {
          ...prevState,
          api: apiValue,
        };
      });
    },
  };
};

export const useHeaderFieldsStore = createAppStore(headerFieldsStore);
